import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu-task",
  "use": "icon-menu-task-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-menu-task\">\r\n<g>\r\n\t<path d=\"M184,22.3h-20.9c-3,0.1-5.3,2.5-5.3,5.5c0,0,0,0,0,0v5.6c0,2.8-2.3,5.1-5.2,5.1h-104c-2.8,0-5.2-2.3-5.2-5.1v-5.9\r\n\t\tc-0.1-2.8-2.3-5.1-5.2-5.3H15.8C7,22.2,0,29.3,0,38v146.5c0.1,8.6,7.1,15.5,15.8,15.5h168.4c8.7,0,15.8-6.9,15.8-15.5V38\r\n\t\tC199.8,29.3,192.7,22.4,184,22.3z M149.4,93.5l-53.6,54.7c-2.1,2-4.8,3.2-7.7,3.3c-2.7,0-5.2-1.1-7.1-3L50,119.5\r\n\t\tc-3.8-4.3-3.3-10.8,1-14.6c0,0,0,0,0,0c3.8-2.9,9.2-2.9,13.1,0l24,22.3L134,79.7c4.2-4.1,10.8-4.1,15,0c3.8,4,3.8,10.3,0,14.2\r\n\t\tL149.4,93.5z M139,23.8H61c-2.8,0-5-2.2-5-5V5c0-2.8,2.2-5,5-5l78,0c2.8,0,5,2.2,5,5v13.8C144,21.5,141.7,23.8,139,23.8z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/menu-task.svg
// module id = LsbB
// module chunks = 13